import { eventbus } from './eventbus';
/**
 * 批量注册事件
 * @param eventMap 事件映射表
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerEvents(eventMap) {
    for (var _i = 0, _a = Object.entries(eventMap); _i < _a.length; _i++) {
        var _b = _a[_i], eventName = _b[0], handler = _b[1];
        eventbus.on(eventName, handler);
    }
    var unregister = function () {
        for (var _i = 0, _a = Object.entries(eventMap); _i < _a.length; _i++) {
            var _b = _a[_i], eventName = _b[0], handler = _b[1];
            eventbus.off(eventName, handler);
        }
    };
    return { unregister: unregister };
}
